// initial state
const state = {
    givenAnswers: {
        operational: {},
        structural: {},
        emotional: {},
        sustainable: {}
    }
}

// getters
const getters = {
    operational: (state) => state.givenAnswers.operational,
    structural: (state) => state.givenAnswers.structural,
    emotional: (state) => state.givenAnswers.emotional,
    sustainable: (state) => state.givenAnswers.sustainable
}

// actions
const actions = {
    saveAnswer(context, answerObj) {
        switch (answerObj.section) {
            case 'operationalTransferability':
                context.commit('ADD_ANSWER_OPERATIONAL', answerObj.answer)
                break
            case 'structuralTransferability':
                context.commit('ADD_ANSWER_STRUCTURAL', answerObj.answer)
                break
            case 'emotionalTransferability':
                context.commit('ADD_ANSWER_EMOTIONAL', answerObj.answer)
                break
            case 'sustainableProfitability':
                context.commit('ADD_ANSWER_SUSTAINABLE', answerObj.answer)
                break
        }
    }
}

// mutations
const mutations = {
    ADD_ANSWER_OPERATIONAL(state, answer) {
        if (!state.givenAnswers.operational[answer.step]) {
            state.givenAnswers.operational[answer.step] = {}
        }
        state.givenAnswers.operational[answer.step]['answerId'] = answer.id
        state.givenAnswers.operational[answer.step]['answer'] = answer.value
        state.givenAnswers.operational[answer.step]['step'] = answer.step
        state.givenAnswers.operational[answer.step]['point'] = answer.point
        state.givenAnswers.operational[answer.step]['ans'] = answer.ans
    },
    ADD_ANSWER_STRUCTURAL(state, answer) {
        if (!state.givenAnswers.structural[answer.step]) {
            state.givenAnswers.structural[answer.step] = {}
        }
        state.givenAnswers.structural[answer.step]['answerId'] = answer.id
        state.givenAnswers.structural[answer.step]['answer'] = answer.value
        state.givenAnswers.structural[answer.step]['step'] = answer.step
        state.givenAnswers.structural[answer.step]['point'] = answer.point
        state.givenAnswers.structural[answer.step]['ans'] = answer.ans
    },
    ADD_ANSWER_EMOTIONAL(state, answer) {
        if (!state.givenAnswers.emotional[answer.step]) {
            state.givenAnswers.emotional[answer.step] = {}
        }
        state.givenAnswers.emotional[answer.step]['answerId'] = answer.id
        state.givenAnswers.emotional[answer.step]['answer'] = answer.value
        state.givenAnswers.emotional[answer.step]['step'] = answer.step
        state.givenAnswers.emotional[answer.step]['point'] = answer.point
        state.givenAnswers.emotional[answer.step]['ans'] = answer.ans
    },
    ADD_ANSWER_SUSTAINABLE(state, answer) {
        if (!state.givenAnswers.sustainable[answer.step]) {
            state.givenAnswers.sustainable[answer.step] = {}
        }
        state.givenAnswers.sustainable[answer.step]['answerId'] = answer.id
        state.givenAnswers.sustainable[answer.step]['answer'] = answer.value
        state.givenAnswers.sustainable[answer.step]['step'] = answer.step
        state.givenAnswers.sustainable[answer.step]['point'] = answer.point
        state.givenAnswers.sustainable[answer.step]['ans'] = answer.ans
    },
    RESET_ANSWERS(state) {
        state.givenAnswers = {
            operational: {},
            structural: {},
            emotional: {},
            sustainable: {}
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
